import { game } from '../main';
import { Bubble } from './Bubble';
import { changeTexture } from '../utils/changeTexture';
//import { storage } from 'GBCXPromo';
import { playSound } from '../handlers/playSound';
import { GameUI } from './GameUI';

declare const GBCXPromo;

export class EffectPart extends Phaser.Image {
  private animIndex: number = 1;
  private delay: number = 0;
  private soundPlayed: boolean = false;
  private pointsToAdd: number;
  private initGfx: string;
  private pointsSignal: Phaser.Signal;

  private frameAnimation = true;

  constructor(pointsSignal: Phaser.Signal) {
    // @ts-ignore
    super(game, 0, 0, null);

    this.pointsSignal = pointsSignal;
    this.anchor.setTo(0.5);
    this.kill();
  }

  public init(bubble: Bubble, delay: number): void {
    this.revive();
    this.frameAnimation = bubble.typeName !== 'bomb';
    this.pointsToAdd = bubble.pointsAfterBurst;
    this.x = bubble.x;
    this.y = bubble.y;
    this.scale.x = 1;
    this.scale.y = 1;
    this.alpha = 1;
    this.animIndex = 1;
    this.delay = delay;
    this.soundPlayed = false;

    changeTexture(this, bubble.frameName);
    this.initGfx = bubble.frameName;
  }

  public update(): void {
    if (!this.alive) return;

    if (!GBCXPromo.storage.getStorageValue('animations', true)) {
      this.pointsSignal.dispatch(this.pointsToAdd);
      playSound('bubble_pops_' + game.rnd.between(1, 3));
      this.kill();
      return;
    }

    this.delay--;

    if (GameUI.isBomb){
      this.delay = 0;
      this.updateFrameAnimation();
      playSound('bubble_pops_1');
      // this is disgusting but it does the job
      setTimeout(()=> {
        GameUI.isBomb = false;
      }, 500);
      return;
    }

    if (this.delay <= 0) {

      if (!this.soundPlayed) {
        this.pointsSignal.dispatch(this.pointsToAdd);
        this.soundPlayed = true;
        if (!game.config.gameOver) playSound('bubble_pops_' + game.rnd.between(1, 3));
      }

      this.frameAnimation ? this.updateFrameAnimation() : this.updateFadeOutAnimation();
    }
  }

  private updateFrameAnimation() {
    this.animIndex += 0.4;

    if (this.animIndex >= 6) {
      this.kill();
    } else {
      if (this.initGfx == "0_bubble_bomb") this.initGfx = "0_bubble_blue"
      changeTexture(this, this.initGfx + '_0' + Math.floor(this.animIndex));
    }
  }

  private updateFadeOutAnimation() {
    this.scale.x += 0.07;
    this.scale.y += 0.07;
    this.alpha -= 0.05;
    if (this.alpha < 0) this.kill();
  }
}
